"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorldGovernmentPartnership = void 0;
var Tags_1 = require("../../Tags");
var Card_1 = require("../../Card");
var CardType_1 = require("../../CardType");
var CardName_1 = require("../../../CardName");
var constants_1 = require("../../../constants");
var PartyHooks_1 = require("../../../turmoil/parties/PartyHooks");
var PartyName_1 = require("../../../turmoil/parties/PartyName");
var CardRenderer_1 = require("../../render/CardRenderer");
var PlaceOceanTile_1 = require("../../../deferredActions/PlaceOceanTile");
var Resources_1 = require("../../../Resources");
var WorldGovernmentPartnership = (function (_super) {
    __extends(WorldGovernmentPartnership, _super);
    function WorldGovernmentPartnership() {
        return _super.call(this, {
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.WORLD_GOVERNMENT_PARTNERSHIP,
            tags: [Tags_1.Tags.EARTH, Tags_1.Tags.SPACE],
            cost: 28,
            metadata: {
                description: 'Raise temperature 1 step, raise oxygen 1 step and place an ocean tile. Remove up to 3 plants from EACH opponent.',
                cardNumber: 'L412',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.temperature(1).oxygen(1).oceans(1).br;
                    b.minus().plants(-3).any.asterix();
                }),
            },
        }) || this;
    }
    WorldGovernmentPartnership.prototype.canPlay = function (player) {
        var temperatureSteps = player.game.getTemperature() < constants_1.MAX_TEMPERATURE ? 1 : 0;
        var oxygenSteps = player.game.getTemperature() < constants_1.MAX_OXYGEN_LEVEL ? 1 : 0;
        var oceansSteps = player.game.board.getOceansOnBoard() < constants_1.MAX_OCEAN_TILES ? 1 : 0;
        var totalSteps = temperatureSteps + oxygenSteps + oceansSteps;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player.game, PartyName_1.PartyName.REDS)) {
            return player.canAfford(player.getCardCost(this) + totalSteps * constants_1.REDS_RULING_POLICY_COST, { titanium: true });
        }
        return true;
    };
    WorldGovernmentPartnership.prototype.play = function (player) {
        player.game.increaseTemperature(player, 1);
        player.game.increaseOxygenLevel(player, 1);
        player.game.defer(new PlaceOceanTile_1.PlaceOceanTile(player));
        var candidates = player.game.getPlayers().filter(function (p) { return p.id !== player.id && !p.plantsAreProtected() && p.plants > 0; });
        candidates.forEach(function (p) {
            p.deductResource(Resources_1.Resources.PLANTS, 3, { log: true, from: player });
            return undefined;
        });
        return undefined;
    };
    return WorldGovernmentPartnership;
}(Card_1.Card));
exports.WorldGovernmentPartnership = WorldGovernmentPartnership;
//# sourceMappingURL=WorldGovernmentPartnership.js.map